import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { Event } from '@/types';
import { eventService } from '@/services/eventService';

interface EventState {
  selectedEvent: Event | null;
  loading: boolean;
  error: string | null;
}

const initialState: EventState = {
  selectedEvent: null,
  loading: false,
  error: null,
};

// Async thunk for fetching event data
export const fetchEvent = createAsyncThunk(
  'event/fetchEvent',
  async (eventId: string, { rejectWithValue }) => {
    try {
      const event = await eventService.getEvent(eventId);
      return event;
    } catch (error) {
      return rejectWithValue('Error fetching event data');
    }
  }
);

const eventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    clearSelectedEvent: (state) => {
      state.selectedEvent = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEvent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEvent.fulfilled, (state, action: PayloadAction<Event | null>) => {
        state.loading = false;
        state.selectedEvent = action.payload;
      })
      .addCase(fetchEvent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearSelectedEvent } = eventSlice.actions;
export default eventSlice.reducer; 